import { atom, selector } from 'recoil'

export const fasciaDiNonDisturboState = atom({
  key: 'emailSendingWizardFasciaDiNonDisturboStateState',
  default: {
    enable: false,
    isFirstConfiguration: true,
    isDirty: false,
    Start: {
      hours: 0,
      minutes: 0
    },
    End: {
      hours: 7,
      minutes: 0
    }
  }
})

export const fasciaDiNonDisturboInvalidSelector = selector({
  key: 'emailSendingWizardSetFasciaDiNonDisturboValid',
  get: ({ get }) => {
    const { Start, End, enable } = get(fasciaDiNonDisturboState)
    if (Start.hours === End.hours && Start.minutes === End.minutes && enable) {
      return true
    } else {
      return false
    }
  }
})
